import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import App from './App.jsx'
import './styles/index.css'
import { captureTracking } from './utils/tracking'

captureTracking()   // bắt nguồn (utm/fbclid/zalo/referrer) ngay khi tải trang

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: { background: '#333', color: '#fff' },
          success: { duration: 3000, style: { background: '#10b981' } },
          error: { duration: 4000, style: { background: '#ef4444' } },
        }}
        containerStyle={{ top: 70 }}
      />
    </BrowserRouter>
  </React.StrictMode>,
)
